import './PopupSelect'
import '../../GridView'

/** @namespace UI.Widget.Forms.Control */
NS('UI.Widget.Forms.Control');

/**
 * @class
 * @extends UI.Widget.Forms.Control.PopupSelect
 */
UI.Widget.Forms.Control.ReferenceSelect = Class(
    UI.Widget.Forms.Control.PopupSelect,
    /** @lends UI.Widget.Forms.Control.ReferenceSelect.prototype */
    {
        template: "UI/Widget/Forms/Control/ReferenceSelect/Control",
        itemTemplate: "UI/Widget/Forms/Control/ReferenceSelect/Item",
        windowTemplate: "UI/Widget/Forms/Control/ReferenceSelect/Window",
        $createButton: null,
        columns: [],
        itemsGrid: null,
        /**
         * @protected
         */
        createElement() {
            this.ParentCall();

            this.$createButton = this.$('.ctrl-psel-create');
            this.$createButton.on('click', ::this.onCreateClick);

            this.createItemsGrid();
        },
        /**
         * @protected
         */
        removeElement() {
            this.itemsGrid.destroy() && (this.itemsGrid = null);
            this.ParentCall();

            this.$createButton = null;
        },

        /**
         * @protected
         */
        updateElement() {
            this.itemsGrid.reset();
        },

        /**
         * @return {UI.Widget.DataGridView}
         * @protected
         */
        createGrid(options) {
            return this.Parent({
                showHeader: true
            }).on('update', () => {
                _.forEach(this.getValue(), (value) => {
                    this.grid.selectItem({id: value}, this.multiple ? 'multiple' : undefined)
                });
            });
        },
        /**
         * @return {UI.Widget.GridView}
         * @protected
         */
        createItemsGrid() {
            this.itemsGrid = new UI.Widget.DataGridView(this.parent, {
                source: _.get(this.parent, this.$control.attr("source")),
				args: {attribute: this.$control.attr("attribute")}, // если в объекте 2 атрибута ссылаются на один датасоурс
																	// то в frontend/js/Data/ServerSource.js:162 апросы получат одинаковые хеши
																	// и из всех запросов выполнится только последний, остальные будут сброшены
                actions: [{
					enabled: check('Accounting.Kinds.' + this.filter.kindid, [Security.AccessMode.Update]),
				}],
                filter: {...this.filter, id: (this.getValue()&&this.getValue().length?this.getValue():[0])},
                columns: this.columns,
                createEnabled: false,
                showFooter: false,
            });

            this.itemsGrid.on('editItem', ::this.onItemsGridItemEditItem)
				.on('removeItem', ::this.onItemsGridItemRemoveItem)
                .render()
                .appendTo(this.$('.ctrl-psel-items'));

            return this.itemsGrid;
        },
        /**
         * @protected
         */
        reset() {
            this.ParentCall();
            this.itemsGrid.reset();
        },
        /**
         * @protected
         */
        async createItemForm(id) {
            const itemFormClass = this.$control.attr('item-form');
            if (!itemFormClass) { return; }

            try {
                var $createFormContainer = $(this.$control.attr('create-form-container'));
                $createFormContainer.length || ($createFormContainer = this.parent.container());

                if (id) {
					const kind = (await this.parent.kindsSource.getDocument({
						id: this.filter.kindid
					}))['item'];
					var item = (await this.ds.getDocument({id: id}))['item'];
					item.kindname = kind.name;
					item.kind = kind;
				} else {
					const createReferenceHelper = _.get(this.parent, this.$control.attr('create-reference-helper'));
					var item = await Promise.resolve(
						_.isFunction(createReferenceHelper) ?
							createReferenceHelper.call(this.parent, this) :
							this.ds.create()
					);
				}

                const itemForm = Util.create(itemFormClass, [ this.parent, {
                    item: item
                } ]);

                itemForm.on('save', ::this.onSelectItem)
                    .render()
                    .appendTo($createFormContainer);

                const afterRenderCreateForm = _.get(this.parent, this.$control.attr('after-render-create-form'));
                Util.call(afterRenderCreateForm, this.parent, [ itemForm ]);

                return itemForm;
            } catch (err) {
                console.error(err.stack);
            }
        },
        /**
         * @protected
         */
        onCreateClick() {
            this.createItemForm();
        },

        /**
         * @param id
         * @protected
         */
        onItemsGridItemRemoveItem({ item: { id } }) {
            const value = this.getValue();
            let valueKey = this.valueKey;
            if (_.indexOf(value, id) != -1) {
                _.remove(value,(n)=>{return n==id});
                this.itemsGrid.filter = {...this.filter, id: (value&&value.length?value:[0])};
                this.itemsGrid.removeItem({id: id});
                this.setValue(value, false);

            }
        },
		/**
		 * @param id
		 * @protected
		 */
		onItemsGridItemEditItem ({ item: { id } }) {
			this.createItemForm(id);
		},

        /**
         * @param {{ item: Object }} evt
         * @protected
         */
        onSelectItem(evt) {
            let value = this.getValue() || [];

            let index = _.indexOf(this.value, evt.item[this.valueKey]);

            if (index !== -1) {
                this.value.splice(index, 1);
                this.grid && this.grid.deselectItem(evt.item);
            } else {
                if (this.multiple) {
                    value.push(evt.item[this.valueKey]);
                } else {
                    value = [ evt.item[this.valueKey] ];
                }
                this.grid && this.grid.selectItem(evt.item, this.multiple ? 'multiple' : undefined);
            }

            const filter = _.clone(this.filter);

            filter[this.valueKey] = (value&&value.length?value:[0]);
            this.itemsGrid.filter = filter;

            this.setValue(value, true);

            if (!this.multiple) {
                this.destroyPopup();
            }
        },
        editMode () {
            this.ParentCall()
            this.$('.ctrl-psel-buttons').show()
            this.$('.ctrl-psel-item .remove').show()
        },
        viewMode () {
            this.ParentCall()
            this.$('.ctrl-psel-buttons').hide()
            this.$('.ctrl-psel-item .remove').hide()
        },
    }
);
